import { useDispatch, useSelector } from "react-redux"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { CashboxCategory } from "src/common/models/cashboxCategory"
import { PageCard } from "src/common/styles/styles"
import { SearchableTable } from "src/components/SearchableTable"
import { RootState } from "src/state/reducer"
import { GET_CASHBOX_CATEGORIES_API } from "../state/actionTypes"
import { TABLE_COLUMNS } from "./config"
import { ColumnsType } from "antd/es/table"
import { useEffect, useState } from "react"
import { getCashboxCategoriesApi } from "../state/action"
import { SystemDescriptions } from "src/common/descriptions"
import { CreateCashboxCategory } from "../CreateCashboxCategory"
import useUserPermission from "src/hooks/useUserPermissions"
import { USER_SCOPES } from "src/hooks/UserPermission"

export type ReduxProps = {
    cashboxCategories?: CashboxCategory[],
    isGettingRecords: boolean
}

export const CashboxCategories = () => {
    const dispatch = useDispatch()
    const { validateUserScopeForPage } = useUserPermission()

    const [createOpen, setCreateOpen] = useState(false)

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.CASHBOX_CATEGORY_READ)
        dispatch(getCashboxCategoriesApi())
    }, [])

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        cashboxCategories: state.cashbox.cashboxCategories || [],
        isGettingRecords: serviceLoading(state, [GET_CASHBOX_CATEGORIES_API]),
    }))

    const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CASHBOX_CATEGORIES

    const tblColumns: ColumnsType<CashboxCategory> = [
        ...TABLE_COLUMNS,
    ]

    const handleActionButtonClick = () => {
        setCreateOpen(true)
    }

    return (
        <>
            <PageCard
                size="small"
                title={descriptions.TITLE}
            >
                <SearchableTable
                    showSearch
                    showLoader={reduxProps.isGettingRecords}
                    items={reduxProps.cashboxCategories || []}
                    tableColumns={tblColumns as any}
                    searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
                    showActionButton
                    actionButtonOnClick={handleActionButtonClick}
                    actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
                />
            </PageCard>
            <CreateCashboxCategory
                open={createOpen}
                onAccept={() => {
                    setCreateOpen(false)
                    dispatch(getCashboxCategoriesApi())
                }}
                onCancel={() => { setCreateOpen(false) }}
            />
        </>
    )
}
